// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductEmbellishments_wrapper__3c_rS","table":"ProductEmbellishments_table__sPJi6"};